import React from 'react'
import '../styles/header.css'
import Logo from '../images/header/logo_rot.png'
import { IoMdArrowDroprightCircle } from "react-icons/io";


// https://www.remove.bg/ for background removal

const Header = ({ image }) => {
    return (
        <header className='header-container'>
            <div className='logo-image-comtainer'>
                <img src={Logo} alt='herz-doctor-logo' className='logo-image'/>
            </div>   
            

            <div className='header-descritpion-container'>
                <div>
                    <h1> Willkommen bei Dr. Claudia Sebald! </h1>
                    <ul className='header-list'>
                        <li> <IoMdArrowDroprightCircle className='list-arrow'/> Fachärztin für Innere Medizin und Kardiologie </li>
                        <li> <IoMdArrowDroprightCircle className='list-arrow'/> Ordination Wien - alle Kassen </li>
                        <li> <IoMdArrowDroprightCircle className='list-arrow'/> Ordination mit Herz </li>
                    </ul>
                </div>
        
                <div className='header-image-container'> 
                    <img  src={image} alt="herz-doctor-header image" className='header-image'/>
                </div>
            </div>
        </header>
    )
}

export default Header;